import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Input,
  ModalFooter,
  Button,
} from '@chakra-ui/react';

// Shared Modal Component
interface CustomModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedId: string | null;
  name: string;
  handleEdit: () => void;
  handleAdd: () => void;
  handleNameChange: (value: string) => void;
}

export const CustomModal: React.FC<CustomModalProps> = ({
  isOpen,
  onClose,
  selectedId,
  name,
  handleEdit,
  handleAdd,
  handleNameChange,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{selectedId ? 'Edit' : 'Add'}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel>Name</FormLabel>
            <Input value={name} onChange={(e) => handleNameChange(e.target.value)} />
          </FormControl>
        </ModalBody>
        <ModalFooter justifyContent="space-between">
          {selectedId ? (
            <Button colorScheme="blue" onClick={handleEdit}>
              Save Changes
            </Button>
          ) : (
            <Button colorScheme="blue" onClick={handleAdd}>
              Add Category
            </Button>
          )}
          <Button onClick={onClose} colorScheme="gray">
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
